import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { icons } from '@/components/Base/Lucide';

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
  selectedUserId?: string;
}

const initialState: SideMenuState = {
  menu: [
    'HOME',
    {
      icon: 'LayoutDashboard',
      pathname: '/',
      title: 'Dashboard',
    },
    'REPORTS',
    {
      icon: 'FileSpreadsheet',
      pathname: '/data-report',
      title: 'Data Report',
    },
  ],
  selectedUserId: undefined,
};

export const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {
    setCompanyId: (state, action) => {
      const companyId = action.payload;
      state.menu = state.menu.map((item) => {
        if (typeof item !== 'string') {
          /* reserved for multi-tenant path rewrites */
        }
        return item;
      });
    },
    setUserId: (state, action) => {
      state.selectedUserId = action.payload;
    },
  },
});

export const { setCompanyId, setUserId } = sideMenuSlice.actions;

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;
